import { Map } from 'immutable';
import companyActions from './actions';

const companies = [];// new fakeData(1).getAll();

const initState = new Map({
  companies,
  selectedId: 0,
  editView: false,
});

export default function companyReducer(state = initState, action) {
  switch (action.type) {
    case companyActions.ADD_COMPANY:
      return state
        .set('companies', action.companies)
        .set('selectedId', action.selectedId)
        .set('editView', false);
    case companyActions.EDIT_COMPANY:
      return state.set('companies', action.companies);
    case companyActions.EDIT_COMPANY_VIEW:
      return state.set('editView', action.view);
    default:
      return state;
  }
}

export { companies };



// WEBPACK FOOTER //
// ./src/redux/company/reducer.js